import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Navbar from './Components/navbar';
import HomeScreen from "./Pages/HomeScreen";
import Winkel from "./Pages/Winkel";
import Contact from "./Pages/Contact";
import OverOns from "./Pages/OverOns";
import Fotos from "./Pages/Fotos";
import Footer from "./Components/footer";

function App() {
  return (
    <Router>
      <div>
        <Navbar />
        <Routes>
        <Route path="/home" element={<Navigate to="/" />} />

          <Route path="/" element={<HomeScreen />} />
          <Route path="/bestellen" element={<Winkel />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/over-ons" element={<OverOns />} />
          <Route path="/foto's" element={<Fotos />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;